import {
    PARTNER_COST_UPLOAD_SUCCESS, PARTNER_COST_UPLOAD_FAIL, PARTNER_COST_DATA_DOWNLOAD_FAILURE, PARTNER_COST_DATA_DOWNLOAD_SUCCESS,
    PARTNER_COST_DATA_DOWNLOAD_TEMPLATE_SUCCESS, PARTNER_COST_DATA_DOWNLOAD_TEMPLATE_FAILURE
} from './action';
const initialState = {
    partnerCostUploadSuccessMsg: null,
    partnerCostUploadFail: [],
    downloadPartnerCostExcelSuccess:null,
    downloadPartnerCostExcelFail:null,
    downloadPartnerCostExcelTemplateSuccess:[],
    downloadPartnerCostExcelTemplateFail:null,
}

const partnerCostReducer = (state = initialState, action) => {
    switch (action.type) {
        case PARTNER_COST_UPLOAD_SUCCESS:
            return state = {
                ...state,
                partnerCostUploadSuccessMsg: action.data
            }
        case PARTNER_COST_UPLOAD_FAIL:
            return state = {
                ...state,
                partnerCostUploadFail: action.data.response
            }

        case PARTNER_COST_DATA_DOWNLOAD_SUCCESS:
                return {
                    ...state,
                    downloadPartnerCostExcelSuccess: action.data
                }

        case PARTNER_COST_DATA_DOWNLOAD_FAILURE:
            return {
                ...state,
                downloadPartnerCostExcelFail: action.data
            }

            case PARTNER_COST_DATA_DOWNLOAD_TEMPLATE_SUCCESS:
                return {
                    ...state,
                    downloadPartnerCostExcelTemplateSuccess: action.data
                }

        case PARTNER_COST_DATA_DOWNLOAD_TEMPLATE_FAILURE:
            return {
                ...state,
                downloadPartnerCostExcelTemplateFail: action.data
            }
        default: return state
    }
}
export default partnerCostReducer;
